var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcShoppingCart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.25,
    height: 27.507,
    viewBox: "0 0 27.25 27.507",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6ihccvagsa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 902",
    d: "M0 0h27.25v27.507H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1954",
    style: {
      clipPath: "url(#6ihccvagsa)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3317",
    d: "M2.935 1.9c-.667 0-1.317.008-1.966 0A.943.943 0 0 1 .073.6.886.886 0 0 1 .919.009q1.452-.017 2.9 0a.929.929 0 0 1 .919.876c.125 1.158.242 2.317.364 3.475.012.117.032.234.053.384H25.27a1.853 1.853 0 0 1 1.957 1.538 3.351 3.351 0 0 1-.088 1.167q-1.076 5.1-2.181 10.184a2.824 2.824 0 0 1-2.852 2.283H7.47a2.847 2.847 0 0 1-2.912-2.657c-.278-2.73-.577-5.458-.865-8.187q-.369-3.5-.732-7.01c0-.039-.012-.077-.026-.164m22.441 4.76H5.357c.005.072.008.129.014.185l.315 2.974.765 7.245a.953.953 0 0 0 1.079.962h14.516a.967.967 0 0 0 1.079-.874q.77-3.572 1.533-7.146l.718-3.346"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3318",
    d: "M8.53 27.506a2.844 2.844 0 1 1 2.85-2.838 2.854 2.854 0 0 1-2.85 2.838m0-1.9a.948.948 0 1 0-.943-.944.956.956 0 0 0 .943.944"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3319",
    d: "M22.759 24.656a2.844 2.844 0 1 1-2.849-2.838 2.853 2.853 0 0 1 2.849 2.838m-1.9.012a.947.947 0 1 0-.946.941.956.956 0 0 0 .946-.941"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcShoppingCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-shoppingCart.1846fe4dc08c807939b59ec3081aa830.svg";